/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankListResponse } from '../models/BankListResponse';
import type { CounterpartyDropDownListResponse } from '../models/CounterpartyDropDownListResponse';
import type { CounterpartyType } from '../models/CounterpartyType';
import type { CurrencyDropDownListResponse } from '../models/CurrencyDropDownListResponse';
import type { TagDropDownListResponse } from '../models/TagDropDownListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DropDownHelperService {
    /**
     * This method returns the list of counterparties by for a drop-down selection
     * @param companyId The company id
     * @param type The counterparty type
     * @param searchParam The counterparty name, registration number or VAT number
     * @returns CounterpartyDropDownListResponse OK
     * @throws ApiError
     */
    public static getAllDropDownCounterparties(
        companyId: number,
        type: CounterpartyType,
        searchParam?: string,
    ): CancelablePromise<CounterpartyDropDownListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{companyId}/counterparties/drop-down',
            path: {
                'companyId': companyId,
            },
            query: {
                'type': type,
                'searchParam': searchParam,
            },
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method returns the list of currencies for a drop-down selection in invoice screen
     * @returns CurrencyDropDownListResponse OK
     * @throws ApiError
     */
    public static getAllCurrenciesForDropDown(): CancelablePromise<CurrencyDropDownListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/drop-down/currencies',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method returns the list of banks for a drop-down selection in invoice screen
     * @returns BankListResponse OK
     * @throws ApiError
     */
    public static getAllBanksForDropDown(): CancelablePromise<BankListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/drop-down/banks',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method returns the list of tags for a drop-down selection in invoice screen
     * @param companyId The company id
     * @returns TagDropDownListResponse OK
     * @throws ApiError
     */
    public static getAllTagsByCompanyIdForDropDown(
        companyId: number,
    ): CancelablePromise<TagDropDownListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{companyId}/tags',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
}
